import { post } from "../../contexts/apicontexts";
import config from "../../config";

const BASE = `${config.baseurl}CustomerTicketAnalytics`;

const n = (v, fallback = 0) => { const p = Number(v); return Number.isFinite(p) ? p : fallback; };
const s = (v, fallback = "") => (typeof v === "string" ? v : typeof v === "number" ? String(v) : fallback);

function normalizeSummary(raw) {
  const r = raw ?? {};
  return {
    totalTickets:            n(r.totalTickets            ?? r.TotalTickets),
    pendingTickets:          n(r.pendingTickets          ?? r.PendingTickets),
    resolvedTickets:         n(r.resolvedTickets         ?? r.ResolvedTickets),
    totalCustomers:          n(r.totalCustomers          ?? r.TotalCustomers),
    resolutionRate:          n(r.resolutionRate          ?? r.ResolutionRate),
    topPendingCustomer:      s(r.topPendingCustomer      ?? r.TopPendingCustomer),
    topPendingCustomerCount: n(r.topPendingCustomerCount ?? r.TopPendingCustomerCount),
    topResolvedCustomer:     s(r.topResolvedCustomer     ?? r.TopResolvedCustomer),
    topResolvedCustomerCount:n(r.topResolvedCustomerCount?? r.TopResolvedCustomerCount),
    topPriority:             s(r.topPriority             ?? r.TopPriority),
    topPriorityCount:        n(r.topPriorityCount        ?? r.TopPriorityCount),
  };
}

function normalizeTopCustomer(raw) {
  const r = raw ?? {};
  return {
    customerId:   n(r.customerId   ?? r.CustomerId),
    customerName: s(r.customerName ?? r.CustomerName),
    customerCode: s(r.customerCode ?? r.CustomerCode),
    count:        n(r.count        ?? r.Count),
    totalTickets: n(r.totalTickets ?? r.TotalTickets),
  };
}

function normalizeSlice(raw, keyA, keyB) {
  const r = raw ?? {};
  return {
    label:   s(r[keyA] ?? r[keyB]),
    count:   n(r.count ?? r.Count),
    percent: n(r.percent ?? r.Percent),
  };
}

function normalizeTrendPoint(raw) {
  const r = raw ?? {};
  return {
    year:     n(r.year  ?? r.Year),
    month:    n(r.month ?? r.Month),
    label:    s(r.label ?? r.Label),
    total:    n(r.total ?? r.Total),
    pending:  n(r.pending ?? r.Pending),
    resolved: n(r.resolved ?? r.Resolved),
  };
}

export function buildCustomerTicketAnalyticsPayload(filters) {
  const payload = {};
  if (filters.year) payload.Year = Number(filters.year);
  if (filters.mode === "monthly"   && filters.month)   payload.Month   = Number(filters.month);
  if (filters.mode === "quarterly" && filters.quarter) payload.Quarter = Number(filters.quarter);
  return payload;
}

export async function fetchCustomerTicketAnalytics(filters) {
  const payload = buildCustomerTicketAnalyticsPayload(filters);
  const res = await post(`${BASE}/report`, payload);
  if (res?.status !== 200) throw new Error("Customer ticket analytics could not be loaded.");
  const data = res.data ?? {};

  const arr = (a, b) => (Array.isArray(data[a] ?? data[b]) ? (data[a] ?? data[b]) : []);

  return {
    summary:              normalizeSummary(data.summary ?? data.Summary),
    topPendingCustomers:  arr("topPendingCustomers", "TopPendingCustomers").map(normalizeTopCustomer),
    topResolvedCustomers: arr("topResolvedCustomers", "TopResolvedCustomers").map(normalizeTopCustomer),
    priorityBreakdown:    arr("priorityBreakdown", "PriorityBreakdown").map((x) => normalizeSlice(x, "priority", "Priority")),
    statusBreakdown:      arr("statusBreakdown", "StatusBreakdown").map((x) => normalizeSlice(x, "status", "Status")),
    trend:                arr("trend", "Trend").map(normalizeTrendPoint),
  };
}

export function getDefaultCustomerTicketFilters() {
  const now = new Date();
  return {
    mode:    "yearly", // "monthly" | "quarterly" | "yearly"
    year:    String(now.getFullYear()),
    month:   String(now.getMonth() + 1),
    quarter: String(Math.floor(now.getMonth() / 3) + 1),
  };
}
